import { UsersReducerState } from './usersReducer.types';

export const USERS_REDUCER_INITIAL_STATE = Object.freeze<UsersReducerState>({
    users: {},
    hasReceivedUsers: {},
});
